// Camera family detection based on `Device.globalDeviceType` (e.g. "Truman_CX6T").
// Mirrors the device-type list in pilets/camera-pilet/src/pages/AddCamera/cameraTypes.ts —
// duplicated here since the shell cannot import pilet internals.

/** Truman (CX6) cameras are the only family that currently supports Settings. */
export const TRUMAN_CAMERA_DEVICE_TYPES = ["Truman_CX6T"] as const;

export const isTrumanCamera = (globalDeviceType?: string): boolean => {
  if (!globalDeviceType) return false;
  return TRUMAN_CAMERA_DEVICE_TYPES.includes(
    globalDeviceType as (typeof TRUMAN_CAMERA_DEVICE_TYPES)[number]
  );
};
